import { first } from 'rxjs/operators';
import { CommonApiService } from './../../../../services/common-api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bot-info-details',
  templateUrl: './bot-info-details.component.html',
  styleUrls: ['./bot-info-details.component.scss']
})
export class BotInfoDetailsComponent implements OnInit {

  loader: boolean = false;
  meter_id: any;
  bot_name: any;
  constructor(public router: Router,
    public api: CommonApiService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.loader = true;
    this.meter_id = this.route.snapshot.params["meter_id"];
    console.log(this.meter_id);
    this.botInfoDetails()
  }


  botInfoDetails() {
    this.loader = true;
    this.api.botInfoGet(this.meter_id).pipe(first()).subscribe(res => {
      this.loader = false;
      this.bot_name = res;
    })
  }

  botInfoEdit() {
    this.router.navigateByUrl(`/bot-info-edit/${this.meter_id}`);
  }

}
